import { render, staticRenderFns } from "./AttachedFileListDialog.vue?vue&type=template&id=5c888b32"
import script from "./AttachedFileListDialog.vue?vue&type=script&lang=js"
export * from "./AttachedFileListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports